// System banners: messages from the super admin shown at the top of the app
// for all users (server/routes/systemBanners.js). Same values as
// server/models/SystemBanner.js.

export const BANNER_ICONS = [
  "info",
  "warning",
  "error",
  "campaign",
  "build",
  "schedule",
  "update",
  "celebration",
];

// Most serious first - banners are stacked in this order
export const BANNER_COLORS = ["critical", "warning", "info", "success"];

// Whether a banner should be shown right now (its time window has started
// and not ended)
export const isBannerLive = (banner, now = Date.now()) =>
  banner.isActive !== false &&
  (!banner.startsAt || new Date(banner.startsAt).getTime() <= now) &&
  (!banner.endsAt || new Date(banner.endsAt).getTime() > now);
